// Pure helpers over the cloudstorage store's package lists.

// Drop the file `uuid` from every package of `lists` (arrays of packages), in
// place. A file can sit in several packages, so it leaves all of them.
export function drop_cloud_file(lists, uuid) {
    for (const packages of lists) {
        for (const pkg of packages) {
            if (pkg.files) pkg.files = pkg.files.filter(cf => cf.uuid !== uuid)
        }
    }
}
